import * as React from "react"

export default function RaceIcon(props) {
  return (
    <svg
      width={33}
      height={32}
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.4307 3.34202L20.491 3L20.149 3.93969L16.9402 12.7558L16.4997 13.966L16.0593 12.7558L12.8505 3.93969L12.5085 3L11.5688 3.34202L2.01801 6.81821L0.497559 7.37161L1.6725 8.48406L5.11784 11.7461L4.57538 16.4596L4.39039 18.0671L5.91084 17.5137L14.5219 14.3795L15.4356 16.8898L11.3671 28.0679L13.2465 28.7519L16.4997 19.8136L19.753 28.7519L21.6324 28.0679L17.5639 16.8898L18.4776 14.3795L27.0886 17.5137L28.6091 18.0671L28.4241 16.4596L27.8816 11.7461L31.327 8.48406L32.5019 7.37161L30.9815 6.81821L21.4307 3.34202ZM26.2522 15.0809L19.1616 12.5001L21.6864 5.56343L28.777 8.14419L26.1435 10.6376L25.7804 10.9814L25.8376 11.4781L26.2522 15.0809ZM6.74726 15.0809L13.8379 12.5001L11.3131 5.56343L4.22251 8.14419L6.85598 10.6376L7.21905 10.9814L7.16189 11.4781L6.74726 15.0809Z"
        fill={props.fill}
      />
    </svg>
  )
}